interface TextAreaInputProps extends React.ComponentProps<'textarea'> {
  placeholder: string;
  helperText?: string;
  disabled?: boolean;
  error?: string;
}

export function TextAreaInput({
  placeholder,
  helperText,
  disabled,
  error,
  rows,
  ...props
}: TextAreaInputProps) {
  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-1.5">
      <div
        className={`self-stretch px-3.5 py-2.5 rounded-lg outline-1 outline-offset-[-1px] inline-flex justify-start items-center gap-2 overflow-hidden input-shadow transition-colors ${
          disabled ? 'bg-gray-50' : 'bg-white'
        } ${
          error
            ? 'input-error outline-error-300 focus-within:outline-error-300'
            : 'outline-gray-300 focus-within:outline-blue-300'
        }`}
      >
        <textarea
          className="flex-1 self-stretch justify-start text-gray-500 text-base font-normal leading-normal outline-none resize-none min-h-[120px]"
          rows={rows}
          placeholder={placeholder}
          {...props}
        />
      </div>
      {error ? (
        <div className="self-stretch justify-start text-error-500 text-xs font-normal leading-none">
          {error}
        </div>
      ) : (
        <div className="self-stretch justify-start text-gray-600 text-xs font-normal leading-none">
          {helperText}
        </div>
      )}
    </div>
  );
}
